import parseDialogue from "../../util/parseDialogue";

export const SuperphreakF6 = parseDialogue(`
superphreak:f6:100-400

#100 Excellent work. Welcome to Level Four.
>200 Thanks.

#200 No problem. You earned it. Now try to get to that mysterious node I showed you. Something big is going down, and it looks like it's up to you stop it.
>300 Do you think I can handle it?

#300 I know you can. And S.M.A.R.T is counting on you. Get ready for the level four upgrade, and good luck.
>400 Ready for security level upgrade.
`);
